import { LAB_PANELS, type HaneyFrequency } from "../../lib/labTests";

function HaneyInterval({
  everySample,
  oneOutOf,
  onHaney,
}: {
  everySample: boolean;
  oneOutOf: number;
  onHaney: (patch: Partial<HaneyFrequency>) => void;
}) {
  return (
    <label className="flex flex-wrap items-center gap-1.5">
      <input
        type="radio"
        checked={!everySample}
        onChange={() => onHaney({ everySample: false })}
        aria-label="Haney on one out of N samples"
      />
      One out of
      <input
        type="number"
        min={1}
        step={1}
        value={oneOutOf}
        aria-label="Haney sample interval"
        disabled={everySample}
        onChange={(e) =>
          onHaney({
            oneOutOf: Math.max(1, Math.floor(Number(e.target.value)) || 1),
          })
        }
        className="tnum w-14 rounded border border-line bg-surface px-1 py-0.5 text-fg disabled:opacity-50"
      />
      samples
      <span className="text-faint">(min 1 per field)</span>
    </label>
  );
}

export function SoilSampleLabOptions({
  panel,
  onPanel,
  haney,
  onHaney,
}: {
  panel: string;
  onPanel: (panel: string) => void;
  haney: HaneyFrequency;
  onHaney: (patch: Partial<HaneyFrequency>) => void;
}) {
  return (
    <div className="flex flex-col gap-1.5 rounded border border-line/60 bg-surface/40 p-2">
      <label className="flex flex-wrap items-center gap-1.5 text-[11px] text-fg">
        Lab test:
        <select
          value={panel}
          onChange={(e) => onPanel(e.target.value)}
          aria-label="Lab test panel"
          className="rounded border border-line bg-surface px-1 py-0.5 text-fg"
        >
          {LAB_PANELS.map((p) => (
            <option key={p.key} value={p.key}>
              {p.label}
            </option>
          ))}
        </select>
      </label>
      <label className="flex cursor-pointer items-center gap-1.5 text-[11px] text-fg">
        <input
          type="checkbox"
          checked={haney.enabled}
          onChange={() => onHaney({ enabled: !haney.enabled })}
          aria-label="Include Haney soil-health test"
        />
        Include Haney soil-health test
      </label>
      {haney.enabled && (
        <div className="ml-4 flex flex-col gap-1 text-[11px] text-muted">
          <label className="flex cursor-pointer items-center gap-1.5">
            <input
              type="radio"
              checked={haney.everySample}
              onChange={() => onHaney({ everySample: true })}
              aria-label="Haney on every sample"
            />
            On every sample
          </label>
          <HaneyInterval
            everySample={haney.everySample}
            oneOutOf={haney.oneOutOf}
            onHaney={onHaney}
          />
        </div>
      )}
    </div>
  );
}
